import React from 'react'
import AuthenticatedLink from 'components/molecules/AuthenticatedLink'
import intl from 'react-intl-universal'
import times from 'utils/times'
import Typography from 'components/atoms/Typography'
import BaseTemplate from 'components/templates/BaseTemplate'
import triggerEvent from 'utils/dataLayer'

const AptitudeInstruction = () => (
  <BaseTemplate currentPageName={intl.get('aptitude.result.page_name')}>
    <div id="AptitudeInstruction">
      <div className="instuction-box p-a-lg">
        <div className="instuction-title">
          <Typography component="h1" variant="title">
            {intl.getHTML('aptitude.instructions.title')}
          </Typography>
          <Typography component="b" variant="subheadline">
            {intl.getHTML('aptitude.instructions.subtitle')}
          </Typography>
        </div>
        <div className="instuction-points">
          <ol type="1">
            {times(11, i => (
              <li key={i}>{intl.getHTML(`aptitude.instructions.${i + 1}`)}</li>
            ))}
          </ol>
          <div>{intl.getHTML('aptitude.instructions.last')}</div>
        </div>

        <div id="start-button">
          <AuthenticatedLink
            href="/aptitude_test/test/1"
            className="btn btn-primary btn-campus"
            onClick={() => { triggerEvent('aptitude_begin') }}
          >
            {intl.get('aptitude.landing.test_now')}
          </AuthenticatedLink>
        </div>
      </div>
    </div>
  </BaseTemplate>
)

export default AptitudeInstruction
